import { IEntityType } from '@patsnap/synapse_common_interface'
import { useMicroEntityCardWujieProps } from '@pharmsnap/shared/src/composition/useMicroEntityCardWujieProps'
import { IDiseaseCardInfo, IDrugCardInfo, IOrganizationCardInfo, ITargetCardInfo } from '@pharmsnap/shared/src/types'
import { defineComponent, PropType } from '@vue/composition-api'
import WujieVue from 'wujie-vue2'

export const BMicroEntityCard = defineComponent({
  name: 'BMicroEntityCard',
  props: {
    id: {
      type: String,
      required: true,
    },
    /**
     * 目前只有适应症卡片用得到,取适应症的最高研发状态
     */
    drug_id: {
      type: String,
    },
    type: {
      type: String as PropType<IEntityType>,
      required: true,
    },
    data: {
      type: Object as PropType<IDrugCardInfo | ITargetCardInfo | IOrganizationCardInfo | IDiseaseCardInfo>,
    },
    direction: {
      type: String as PropType<'vertical' | 'horizontal'>,
      default: 'horizontal',
    },
  },
  setup(props, { emit }) {
    const {
      props: wujieProps,
      attrs: wujieAttrs,
      microAppName,
      microEntityCardUrl,
      wujieCommonPlugins,
    } = useMicroEntityCardWujieProps<typeof props.data>({
      id: props.id,
      drug_id: props.drug_id,
      type: props.type,
      data: props.data,
      direction: props.direction,
    })

    WujieVue?.bus?.$on('micro-entity-card-loaded', () => {
      emit('loaded')
    })

    return {
      wujieProps,
      wujieAttrs,
      microAppName,
      microEntityCardUrl,
      wujieCommonPlugins,
    }
  },
  render() {
    return (
      <wujie-vue
        plugins={this.wujieCommonPlugins}
        width="100%"
        height="100%"
        name={this.microAppName}
        url={this.microEntityCardUrl}
        {...{
          props: {
            attrs: this.wujieAttrs,
            props: this.wujieProps,
          },
        }}
      />
    )
  },
})
